import formatMoney from '../../core/formatMoney';
import { getProductJson, updateHistory, getVariantsByColor, getVariantBySingleOption, getAvailableProductColors } from './helpers';
import { handleize } from '../../core/helpers';
import variantImages from './variantImages';
// import { propagateWishlistStateToStickyAddToCart } from '../../components/wishlist';
import { listenPDPWishlistButton, updateSocialCount } from '../../components/wishlist';
import { nostoRecommendedVariantViewEvent } from '../../components/nosto/events';
import dynamicProductExtra from './dynamic-product-extra';
import DynamicProductExtraV4 from './dynamic-product-extra-v4';
import { selectSwatch } from '../collection/selectNewColor';  // For product tiles only

let selected_single_option = '';
let selected_color_name = '';
let selected_size_name = '';
let variantSelectionInteraction = '';
let selected_color_variants = [];
let selected_variant = [];
let size_index = document.querySelector('[data-option-size]') ? Number(document.querySelector('[data-option-size]').dataset.optionIndex) : 1;
let params = new URL(window.location.href);
let retry_wishlist = true;
let wishlist_button_init = false;
const pdp_version = (document.querySelector('.template-product-new')) ? 4 : 3;

const announceVariantSelection = (message) => {
  document.querySelectorAll('[data-variant-selection-status]').forEach((el) => {
    el.textContent = '';
    window.setTimeout(() => {
      el.textContent = message;
    }, 10);
  });
};

const ensureVariantAnnouncementTargets = () => {
  document.querySelectorAll('[data-selected-color-label]').forEach((label) => {
    if (label.parentElement?.querySelector('[data-variant-selection-status]')) {
      return;
    }

    const status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('data-variant-selection-status', '');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    label.insertAdjacentElement('afterend', status);
  });

  document.querySelectorAll('[data-selected-size]').forEach((el) => {
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
  });
};

const getSelectedColorDisplayName = () => {
  const activeSwatch = document.querySelector('[data-product-option-color].active');
  if (!activeSwatch) {
    return selected_color_name;
  }

  const swatchAriaLabel = activeSwatch.getAttribute('aria-label') || '';
  const ariaColorName = swatchAriaLabel.replace(/^Color\s+/i, '').trim();

  if (ariaColorName !== '') {
    return ariaColorName;
  }

  return selected_color_name;
};

const placeholder = `
  <svg width="100%" viewBox="0 0 301 461" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_2)">
      <path d="M300.5 0.5H0.5V460.5H300.5V0.5Z" stroke="#ccc" fill="#ddd" stroke-miterlimit="10"/>
    </g>
  </svg>
`;

// All the sizes available for the products are on the page,
// we need to disable the ones that are not available for the selected color
const enableAvailableSizes = () => {
  // const na_size_class = ($('[data-product-overview]').data('oos') && !$('#quicklook-modal').is(':visible')) ? 'inactive' : 'disabled';
  const na_size_class = 'disabled';
  // const na_size_class = ($('#quicklook-modal').is(':visible')) ? 'disabled' : 'inactive';

  const size_items = document.querySelectorAll('[data-product-option-size]');
  size_items.forEach(size_item => {
    size_item.classList.add(na_size_class);
  });

  size_items.forEach(size_item => {
    selected_color_variants.forEach(variant => {
      const size_value = size_item.getAttribute('data-size-value');
      let aria_label = `Size ${size_value} `;
      if (variant.options[size_index] === size_value) {
        if (variant.available) {
          document.querySelectorAll(`[data-product-option-size][data-size-value="${size_value}"]`).forEach(el => {
            el.classList.remove(na_size_class);
            el.removeAttribute(na_size_class);
          });
          document.querySelectorAll(`[data-product-option-size-sticky][data-size-value="${size_value}"]`).forEach(el => {
            el.classList.remove(na_size_class);
            el.removeAttribute(na_size_class);
          });
          aria_label = `Size ${size_value} is available`;
        } else {
          aria_label = `Size ${size_value} is unavailable`;
        }
        document.querySelectorAll(`[data-product-option-size][data-size-value="${size_value}"]`).forEach(el => {
          el.setAttribute('aria-label', aria_label);
        });
        document.querySelectorAll(`[data-product-option-size-sticky][data-size-value="${size_value}"]`).forEach(el => {
          el.setAttribute('aria-label', aria_label);
        });
      }
    });
  });

  // Select the first size available if the active one is not available for the selected color
  const activeLi = document.querySelector('[data-product-option-sizes] li.active');
  if (activeLi && activeLi.classList.contains(na_size_class)) {
    document.querySelectorAll('[data-product-option-sizes] li').forEach(li => li.classList.remove('active'));
    size_items.forEach(size_item => {
      const li = size_item.closest('li');
      if (li && !li.classList.contains(na_size_class) && !document.querySelector('[data-product-option-sizes] li.active')) {
        li.classList.add('active');
        selected_size_name = size_item.getAttribute('data-size-value');
      }
    });
  }

  // const mobileSizes = document.querySelector('[data-product-option-sizes-mobile]');
  // if (selected_color_name === '') {
  //   if (mobileSizes) mobileSizes.setAttribute(na_size_class, na_size_class);
  // } else {
  //   if (mobileSizes) mobileSizes.removeAttribute(na_size_class);
  // }
};

// Get the selected variant by size or the 1st one
const getSelectedVariant = (filter_by_size) => {
  if (filter_by_size) {
    let key = 'option1';
    if (size_index === 1) key = 'option2';
    if (size_index === 2) key = 'option3';

    for (let i = 0; i < selected_color_variants.length; i++) {
      if (selected_color_variants[i][key] === selected_size_name) {
        return selected_color_variants[i];
      }
    }
    return undefined;
  }

  return selected_color_variants[0];
};

const resetErrorMessages = () => {
  const errorElement = document.querySelectorAll('[data-add-to-cart-error]');
  errorElement.forEach(el => el.textContent = '');
  errorElement.forEach(el => el.classList.remove('active'));

  const errorElementSize = document.querySelectorAll('[data-product-option-sizes-error]');
  errorElementSize.forEach(el => el.textContent = '');
  errorElementSize.forEach(el => el.classList.remove('active'));

  const sizeOptions = document.querySelectorAll('[data-option-size]');
  sizeOptions.forEach(el => el.classList.remove('error'));

  const sizeOptionsStickyMobile = document.querySelector('[data-mobile-sticky-add-to-cart-sizes]');
  if (sizeOptionsStickyMobile) {
    sizeOptionsStickyMobile.classList.remove('error');
  }

  const stickyDesktopSizeSelect = document.querySelector('[data-desktop-sticky-add-to-cart-sizes] select');
  if (stickyDesktopSizeSelect) {
    stickyDesktopSizeSelect.classList.remove('error');
    stickyDesktopSizeSelect.setAttribute('aria-invalid', 'false');
  }

  const stickyDesktopSizeError = document.querySelector('[data-product-option-size-desktop-sticky-error]');
  if (stickyDesktopSizeError) {
    stickyDesktopSizeError.textContent = '';
    stickyDesktopSizeError.classList.remove('active');
  }
};

// Update the cart buttons
const updateAddToCartStatus = () => {
  if (typeof selected_variant !== 'undefined' && selected_variant.available) {
    // document.querySelectorAll('[data-add-to-cart]').forEach(el => el.disabled = false);
    document.querySelectorAll('[data-buy-now]').forEach(el => el.disabled = false);
    document.querySelectorAll('[data-add-to-cart-available]').forEach(el => el.classList.remove('visually-hidden'));
    document.querySelectorAll('[data-add-to-cart-unavailable]').forEach(el => el.classList.add('visually-hidden'));
    return;
  }

  // document.querySelectorAll('[data-add-to-cart]').forEach(el => el.disabled = true);
  document.querySelectorAll('[data-buy-now]').forEach(el => el.disabled = true);
  document.querySelectorAll('[data-add-to-cart-available]').forEach(el => el.classList.add('visually-hidden'));
  document.querySelectorAll('[data-add-to-cart-unavailable]').forEach(el => el.classList.remove('visually-hidden'));
};

// Product v4 only
const updateProductFlag = () => {
  if (!document.querySelector('[data-product-flag]') || typeof selected_variant === 'undefined' || selected_variant === null) {
    return;
  }

  let flag = '';

  // Priority: Stock alert > Best Seller app flag > Trending app flag > Style metafield flag > Tag-based flag
  const inventory_quantity = Number(document.querySelector(`[data-product-select] [value="${selected_variant.id}"]`).dataset.inventoryQuantity);
  if (inventory_quantity > 0 && inventory_quantity < 3) {
    flag = 'Only a few left';
  }

  const overview = document.querySelector('[data-product-overview]');

  if (flag === '' && overview) {
    if (typeof overview?.dataset?.mfBestseller !== 'undefined' && parseInt(overview?.dataset?.mfBestseller) <= 30) {
      flag = 'Best Seller';
    }

    if (typeof overview?.dataset?.mfTrending !== 'undefined' && parseInt(overview?.dataset?.mfTrending) <= 30) {
      flag = 'Trending';
    }
  }

  // Tag-based flag
  // We don't show the final sale tags anymore, but they are needed to add a cart note
  if (flag === '') {
    const product = getProductJson();
    const foundTag = product.tags.find(tag => tag.includes('flag:') && !tag.toLowerCase().includes('final sale'));
    if (foundTag) flag = foundTag.replace('flag:', '');
  }

  document.querySelector('[data-product-flag]').innerHTML = flag;
};

// Product v4 only
const updatePaymentWidget = () => {
  const payments_container = document.querySelector('.product-actions__payments');
  if (!payments_container || typeof selected_variant === 'undefined' || selected_variant === null) {
    return;
  }

  payments_container.querySelector('[data-payment-amount]').innerHTML = formatMoney((selected_variant.price / 4), theme.moneyFormat);
  payments_container.classList.add('active');
};

const updateOptionLabels = () => {
  $('[data-product-stock-alert] span').empty();
  $('[data-product-stock-alert]').removeClass('active');
  // $('[data-size-info-unavailable]').removeClass('active');
  // $('#size-unavailable-modal .product-option__sizes').removeClass('active');
  $('[data-oos-has-choice]').removeClass('active');
  $('[data-oos-has-no-choice]').removeClass('active');

  // Show "select a size" instead of "add to bag" when no size is selected
  if (!document.getElementById('digital-gift-card')) {
    // $('[data-product-details] [data-add-to-cart-available]').text(window.theme.strings.selectSize);
    // $('[data-product-details] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.selectSize);
    $('[data-product-details] [data-add-to-cart]').addClass('need-size');
    // $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').text(window.theme.strings.selectSize);
    // $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.selectSize);
    $('[data-mobile-sticky-add-to-cart-button]').addClass('need-size');
    // $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').text(window.theme.strings.selectSize);
    // $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.selectSize);
    $('[data-desktop-sticky-add-to-cart]').addClass('need-size');
  }

  if ($('[data-selected-color]').length) {
    let color_message = 'Please select a color';

    if (selected_color_name === '') {
      $('[data-selected-color]').addClass('unselected');
    } else {
      color_message = getSelectedColorDisplayName();

      // if ($('[data-product-option-size].disabled').length) {
      $('[data-size-info-unavailable]').addClass('active');
      // }

      if ($(`[data-oos-color="${selected_color_name}"]`).length) {
        $(`[data-oos-color="${selected_color_name}"]`).addClass('active');
      }

      // if ($('#size-unavailable-modal .product-option__sizes.active').length) {
      //   $('[data-oos-has-choice]').addClass('active');
      // } else {
      //   $('[data-oos-has-no-choice]').addClass('active');
      // }

      $('[data-selected-color]').removeClass('unselected');
    }

    const normalized_color_message = color_message.replace('Plus Size - ', '');
    $('[data-selected-color]').html(`<span class="color-name">${normalized_color_message}</span>`);

    if (selected_color_name !== '' && variantSelectionInteraction === 'color') {
      announceVariantSelection(`Color ${normalized_color_message} selected.`);
    }
  }

  if ($('[data-selected-size]').length) {
    let size_message = 'Please select a size';

    if (selected_size_name !== '') {
      if ($('[data-product-option-sizes] li.active').length) {
        if ($('[data-selected-size]').length) {
          size_message = selected_size_name;

          // Show "add to bag" instead of "select a size" when a size is selected
          $('[data-product-details] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          $('[data-product-details] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.addToCart);
          $('[data-product-details] [data-add-to-cart]').removeClass('need-size');
          $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.addToCart);
          $('[data-mobile-sticky-add-to-cart-button]').removeClass('need-size');
          $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.addToCart);
          $('[data-desktop-sticky-add-to-cart]').removeClass('need-size');
        }

        // Stock alert
        if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
          const inventory_quantity = Number(document.querySelector(`[data-product-select] [value="${selected_variant.id}"]`).dataset.inventoryQuantity);
          $('[data-product-stock-alert]').removeClass('active');
          if (inventory_quantity > 0 && inventory_quantity < 3) {
            $('[data-product-stock-alert] span').html(inventory_quantity);
            $('[data-product-stock-alert]').addClass('active');
          }
        }
      }
    }

    $('[data-selected-size]').html(size_message);

    if (selected_size_name !== '' && variantSelectionInteraction === 'size') {
      announceVariantSelection(`Size ${size_message} selected.`);
    }
  }

  // Prevent follow-up UI updates in the same flow from replaying stale announcements.
  variantSelectionInteraction = '';

  // Price
  let price_html = '';

  if (typeof selected_variant !== 'undefined') {
    price_html += `<span data-product-price>${formatMoney(selected_variant.price, theme.moneyFormat)}</span>`;
    if (selected_variant.compare_at_price !== null && parseFloat(selected_variant.compare_at_price, 10) > parseFloat(selected_variant.price, 10)) {
      price_html += ` <span class="visually-hidden" data-compare-text>Regular price</span><s data-compare-price>${formatMoney(selected_variant.compare_at_price, theme.moneyFormat)}</s>`;
    }
  }

  // Products with colors and no sizes are not supported yet
  if ($('[data-selected-color]').length && $('[data-selected-size]').length) {
    const product = getProductJson();
    if (selected_color_name === '') {
      // Get the product min price
      price_html = `<span class="product-price--from" data-product-price tabindex="0"><span class="price-from">From </span>${formatMoney(product.price_min, theme.moneyFormat)}</span>`;
    }

    if (selected_color_name !== '' && selected_size_name === '') {
      // Get the min price for the selected color
      let min_price = null;
      selected_color_variants.forEach(variant => {
        if (min_price === null || variant.price < min_price) {
          min_price = variant.price;
        }
      });

      price_html = `<span class="product-price--from" data-product-price tabindex="0"><span class="price-from">From </span>${formatMoney(product.price_min, theme.moneyFormat)}</span>`;
    }
  }

  $('[data-price-wrapper]').html(price_html);

  if (pdp_version === 4) {
    updateProductFlag();
    updatePaymentWidget();
    new DynamicProductExtraV4(selected_color_name);
  } else {
    dynamicProductExtra(selected_color_name);
  }
};

// Update the social networks related data
const updateOG = () => {
  if (typeof selected_variant === 'undefined') {
    return;
  }

  let og_title = encodeURIComponent($('.product-details__title').first().text());
  if ($('[data-selected-color]').length) {
    og_title += ` - ${$('[data-selected-color] .color-name').first().text()}`;
  }

  // const og_price = $('[data-product-price]').first().text().replace('$', '').replace('From', '');

  const og_url = `${window.location.origin}${window.location.pathname}?variant=${selected_variant.id}`;

  // let og_image = '';
  // if (selected_variant.featured_image === null) {
  //   window.setTimeout(() => {
  //     og_image = $('[data-product-slider] [data-slick-index="0"] img').first().attr('src').replace('_945x', '_2250x').replace('_180x', '_2250x');
  //     $('[data-share-pinterest]').attr('href', `//pinterest.com/pin/create/button/?url=${og_url}&media=${og_image}&amp;description=${og_title}`);
  //   }, 1000);
  // } else {

  const og_image = (selected_variant.featured_image) ? selected_variant.featured_image.src : '';
  // }

  // const og_url = window.location.href;

  // Needs to be done server side
  /*
  $('[property="og:url"]').attr('content', og_url);
  $('[property="og:title"]').attr('content', og_title);
  $('[property="og:image:alt"]').attr('content', og_title);
  $('[property="product:price:amount"]').attr('content', og_price);  
  $('[property="og:image"]').attr('content', `http:${og_image}`);
  $('[property="og:image:secure_url"]').attr('content', `https:${og_image}`);
  */

  if (og_image !== '') {
    $('[data-share-pinterest]').attr('href', `//pinterest.com/pin/create/button/?url=${og_url}&media=${og_image}&amp;description=${og_title}`);
  }

  $('[data-share-facebook]').attr('href', `//www.facebook.com/sharer.php?u=${encodeURIComponent(og_url)}`);

  $('[data-share-twitter]').attr('href', `//twitter.com/share?text=${og_title}&url=${encodeURIComponent(og_url)}`);

  $('[data-share-email]').attr('href', `mailto:?subject=${og_title}&body=${og_url}`);
};

// Update model info
const updateModelInfo = () => {
  if ((!document.querySelector('.product-overview-v3') || !document.querySelector('.product-overview-v4')) || !document.querySelector('[data-selected-color]')) {
    return;
  }

  // const selected_color_name = document.querySelector('[data-selected-color] .color-name')?.textContent;
  const selected_color_handle = handleize(selected_color_name);
  const models_data = JSON.parse(document.querySelector('[data-models-json]').innerHTML);

  const model_data = models_data.find(obj => obj.option_color === selected_color_handle);

  if (typeof model_data === 'undefined') {
    document.querySelectorAll('[data-product-model]').forEach(el => el.innerHTML = '');
    document.querySelectorAll('[data-product-model]').forEach(el => {
      const parent = el.closest('.product-model');
      if (parent) parent.classList.add('inactive');
    });
    return;
  }

  let model_html = '<ul>';

  if (typeof model_data.name !== 'undefined' && model_data.name.length) {
    if (typeof model_data.height !== 'undefined' && model_data.height.length) {
      model_html += `<li>${model_data.name} is ${model_data.height}</li>`;
    } else {
      model_html += `<li>${model_data.name}</li>`;
    }
  }

  if (typeof model_data.nationality !== 'undefined' && model_data.nationality.length) {
    model_html += `<li>Nationality | ${model_data.nationality}</li>`;
  }

  if (typeof model_data.size !== 'undefined' && model_data.size.length) {
    model_html += `<li>Size | ${model_data.size}</li>`;
  }

  if (typeof model_data.fav_thing !== 'undefined' && model_data.fav_thing.length) {
    model_html += `<li>Favorite things | ${model_data.fav_thing}</li>`;
  }

  model_html += '</ul>';

  document.querySelectorAll('[data-product-model]').forEach(el => el.innerHTML = model_html);
  document.querySelectorAll('[data-product-model]').forEach(el => {
    const parent = el.closest('.product-model');
    if (parent) parent.classList.remove('inactive');
  });

  // reset the accordion
  window.dispatchEvent(new Event('resize'));
};

const updateWishlistButton = () => {
  if (wishlist_button_init) {
    return;
  }

  if (window._swat) {
    /*
    try {
      if (window.triggerSwymVariantEvent && $('[data-product-swym-wishlist]').length > 0) {
        let selected_product_id = parseInt($('[data-product-swym-wishlist]').data('product-id'), 10);
        const selected_variant_id = parseInt(selected_variant.id, 10);
        // let wishlist_button = '.product-actions__wishlist';
        let wishlist_button = '.swym-add-to-wishlist-view-product';
        const variant_object = {};
        variant_object[`${selected_color_name} / ${selected_size_name}`] = selected_variant_id;

        if ($('#quicklook-modal').is(':visible')) {
          selected_product_id = parseInt($('#quicklook-modal [data-product-swym-wishlist]').data('product-id'), 10);
          // selected_variant_id = parseInt($('#quicklook-modal [data-product-option-color].active').data('variant-id'), 10);
          wishlist_button = '#quicklook-modal .swym-add-to-wishlist-view-product';
        }

        // window.wd_swymProductsInit();
        window.SwymViewProducts[selected_product_id].epi = selected_variant_id;
        window.SwymViewProducts[selected_product_id].iu = window.SwymProductVariants[selected_variant_id].iu;
        window.SwymViewProducts[selected_product_id].variants = [variant_object];
        window.triggerSwymVariantEvent(selected_variant_id);
        window._swat.initializeActionButtons(wishlist_button);

        if ($('.sticky-add-to-cart__wishlist').length) {
          window._swat.initializeActionButtons('.sticky-add-to-cart__wishlist');
        }

        // const is_removing = $('.product-actions__wishlist .swym-button').hasClass('swym-added');

        // Enable/disable the wishlist buttons from the sticky add to cart
        propagateWishlistStateToStickyAddToCart();

        // Update the wishlist counter
        // if (window.swat && window.swat.renderWishlistCount) {
        //   renderWishlistCounter(window.swat);
        // }
      }
    } catch (err) {
      console.warn('Swym selectCallback', err);
    }
    */

    wishlist_button_init = true;
    listenPDPWishlistButton();
    updateSocialCount();
  } else {
    // Retry one more time, it can take time to initialize
    if (!retry_wishlist) {
      return;
    }

    retry_wishlist = false;

    window.setTimeout(() => {
      updateWishlistButton();
    }, 4000);
  }
};

// Select a size from a desktop element or mobile dropdown
const selectSize = (item) => {
  const $item = (item instanceof jQuery) ? item : $(item);
  if ($item.parent().hasClass('active') || $item.hasClass('disabled') || selected_color_name === '') {
    return;
  }

  variantSelectionInteraction = 'size';

  $('[data-product-option-sizes] li').removeClass('active');
  $item.closest('li').addClass('active');

  const product_id = $('#quicklook-modal').is(':visible') ? $item.closest('[data-product-grid-content]').data('product-id') : $('[data-product-overview]').data('product-id');
  selected_size_name = $item.data('size-value');
  // console.log('selected_size_name 1', selected_size_name);
  selected_variant = getSelectedVariant(true);
  // console.log(selected_variant);

  if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
    $('[data-product-select]').val(selected_variant.id).trigger('change');
    nostoRecommendedVariantViewEvent(product_id, selected_variant.id);
  }

  resetErrorMessages();
  updateAddToCartStatus();
  updateHistory();
  updateOptionLabels();
  updateOG();
  updateModelInfo();
  updateWishlistButton();

  // Dispatch events for new functionalities
  if (window.sessionStorage.getItem('sticky-desktop-add-to-cart-size-selected') !== '1') {
    document.dispatchEvent(new Event('astr-pdp-size-selected'));
  }
  window.sessionStorage.removeItem('sticky-desktop-add-to-cart-size-selected');

  /*
  if ($('[data-product-overview]').data('oos') && !$('#quicklook-modal').is(':visible')) {
    window.esc_now_back_in_stock.triggerRefresh();
  }
  */
};

const addPlaceholders = () => {
  // Remove the current product image and thumbs and replace them by placeholders
  document.querySelectorAll('.product-main__image').forEach(el => el.remove());
  document.querySelectorAll('[data-product-thumb]').forEach(el => el.remove());
  document.querySelectorAll('[data-product-mobile-images] .product-main__image').forEach(el => el.remove());

  const main_image_container = document.querySelector('[data-product-main]');
  if (main_image_container) {
    main_image_container.innerHTML = `
    <div class="product-main product-main--placeholder" data-product-main tabindex="0" role="tabpanel">
      ${placeholder}
    </div>`;
  }

  const thumb_images_container = document.querySelector('[data-product-thumbs]');
  if (thumb_images_container) {
    let thumbs_placeholder_html = '';
    for (let i = 0; i < 6; i++) {
      thumbs_placeholder_html += `
        <div class="product-images__thumb product-images__thumb--placeholder" id="control-slide-${i + 1}" role="tab" aria-selected="false" type="button" tabindex="-1" data-product-thumb>
          ${placeholder}
        </div>
      `;
    }

    thumb_images_container.innerHTML = thumbs_placeholder_html;
  }

  const mobile_images_container = document.querySelector('[data-product-mobile-images]');
  if (mobile_images_container) {
    let mobile_placeholder_html = '';
    for (let i = 0; i < 3; i++) {
      mobile_placeholder_html += `
        <div class="product-main product-main--placeholder" data-product-main tabindex="0" role="tabpanel">
          <svg class="product-main__image" width="100%" viewBox="0 0 301 461" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1_2)">
              <path d="M300.5 0.5H0.5V460.5H300.5V0.5Z" stroke="#ccc" fill="#ddd" stroke-miterlimit="10"/>
            </g>
          </svg>
        </div>
      `;
    }

    mobile_images_container.innerHTML = mobile_placeholder_html;
  }
};

// Select the same color on "Complete the Look" items
const updateColorCompleteTheLook = () => {
  const completeLookProducts = document.querySelector('[data-complete-look-products]');
  if (!completeLookProducts) {
    return;
  }

  // console.log('updateColorCompleteTheLook');

  let selected_color_handle = '';
  const productDetails = document.querySelector('[data-product-details]');
  if (productDetails) {
    const activeColor = document.querySelector('[data-product-overview] [data-product-option-color].active');
    if (activeColor) {
      selected_color_handle = activeColor.getAttribute('data-color-handle');
    }
  }

  if (selected_color_handle === '') {
    return;
  }

  const productTiles = completeLookProducts.querySelectorAll('[data-product-tile]');
  productTiles.forEach(item => {
    const colorSwatch = item.querySelector(`[data-color-swatch][data-color-handle="${selected_color_handle}"]`);
    if (colorSwatch) {
      selectSwatch(colorSwatch);
    } else {
      // Select the first color if the selected one is not available
      const firstSwatch = item.querySelector('[data-color-swatch]');
      if (firstSwatch) {
        selectSwatch(firstSwatch);
      }
    }
  });
};

// Only use for the GC product right now since all the other product variants share the same price
const updatePrice = () => {
  const priceElement = document.querySelector('[data-product-overview] [data-product-price]');
  if (!priceElement) {
    return;
  }

  priceElement.innerHTML = formatMoney(selected_variant.price, theme.moneyFormat);
};

const clickColorSwatch = (item) => {
  if (!item) return;

  if (item.classList.contains('active')) {
    return;
  }

  variantSelectionInteraction = 'color';

  addPlaceholders();

  // We need to wait a little due to the size selection
  window.setTimeout(() => {
    document.querySelectorAll('[data-product-option-color]').forEach(el => el.classList.remove('active'));
    item.classList.add('active');

    const quicklookModal = document.getElementById('quicklook-modal');
    const product_id = (quicklookModal && quicklookModal.offsetParent !== null)
      ? item.closest('[data-product-grid-content]').dataset.productId
      : document.querySelector('[data-product-overview]').dataset.productId;

    selected_color_name = item.dataset.colorValue;
    selected_color_variants = getVariantsByColor(selected_color_name);
    enableAvailableSizes();
    selected_variant = getSelectedVariant(document.querySelectorAll('[data-product-option-sizes] li.active').length > 0);

    // Enable the correct size if the previously selected variant didn't have any size available
    if (
      document.querySelectorAll('[data-product-option-sizes] li.active').length === 0 &&
      selected_variant.available && params.searchParams.get('variant')
    ) {
      const sizeLi = document.querySelector(`[data-size-value="${selected_variant.options[size_index]}"]`)?.closest('li');
      if (sizeLi) sizeLi.classList.add('active');
    }

    if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
      document.querySelectorAll('[data-product-select]').forEach(el => {
        el.value = selected_variant.id;
        el.dispatchEvent(new Event('change', { bubbles: true }));
      });
      nostoRecommendedVariantViewEvent(product_id, selected_variant.id);
    }

    if (document.querySelectorAll('[data-product-option-sizes] li.active').length) {
      resetErrorMessages();
      updateAddToCartStatus();
      updateWishlistButton();
      updateHistory();
    }

    variantImages();
    updateOptionLabels(); // after updating the image, we need to update the option labels
    updateOG();
    updateModelInfo();
    updateColorCompleteTheLook();

    // Dispatch events for new functionalities
    document.dispatchEvent(new Event('astr-pdp-color-selected'));
  }, 100);
};

// Price on GC page for instance
const clickSingleOption = (item) => {
  const $item = $(item);
  selected_single_option = $item.val();
  selected_variant = getVariantBySingleOption(selected_single_option);
  // console.log(selected_variant);
  if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
    $('[data-product-select]').val(selected_variant.id).trigger('change');
  }

  resetErrorMessages();
  updateAddToCartStatus();
  updateHistory();
  variantImages();
  updatePrice();
  updateOptionLabels(); // after updating the image, we need to update the option labels
  updateOG();
  updateModelInfo();
  updateWishlistButton();

  document.dispatchEvent(new Event('astr-pdp-amount-selected'));
};

// On first load - Init the correct variant based on the color in url or if only one color is defined for the current product
const selectVariantWithColor = (force_color = '') => {
  try {
    console.log(`[ASTR] selectVariantWithColor(${force_color}) - On first load - Init the correct variant based on the color in url or if only one color is defined for the current product`);

    selected_color_name = (force_color === '') ? params.searchParams.get('color') : force_color;

    document.querySelectorAll('[data-product-details] [data-product-option-sizes] li').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('[data-product-details] [data-product-option-color]').forEach(el => el.classList.remove('active'));

    // If the color is not available, we need to select the 1st available color
    if (typeof document.querySelector('[data-product-details] [data-product-option-color]')?.dataset.colorValue === 'undefined') {
      clickColorSwatch(document.querySelector('[data-product-details] [data-product-option-color]:not(.inactive)'));
      return;
    }

    selected_color_variants = getVariantsByColor(selected_color_name);
    enableAvailableSizes();
    selected_variant = getSelectedVariant(false);

    if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
      clickColorSwatch(document.querySelector(`[data-product-details] [data-product-option-color][data-color-value="${selected_color_name}"]`));
      $('[data-product-details] [data-product-select]').val(selected_variant.id).trigger('change');
    }

    if (!$('#quicklook-modal').is(':visible')) {
      updateHistory();
    }

    // updateAddToCartStatus(); // We don't want to do that at the moment since it would show "out of stock" if the first size (XS) is OOS, better to have a greyed out add to cart button
    // The following is already done when using clickColorSwatch()
    // variantImages();
    // updateOptionLabels(); // after updating the image, we need to update the option labels
    // updateOG();
    // updateModelInfo();
    // updateWishlistButton();

    // Dispatch events for new functionalities
    document.dispatchEvent(new Event('astr-pdp-color-selected'));
  } catch (error) {
    console.log(error);
  }
};

// On first load - Init the correct variant if no color and no variant id provided in url
const selectVariantWithNoParams = () => {
  try {
    console.log('[ASTR] selectVariantWithNoParams - On first load - Init the correct variant if no color and no variant id provided in url');

    selected_color_name = document.querySelector('[data-product-details] [data-product-option-color]:not(.inactive)')?.dataset.colorValue;

    // Preselect the 1st color
    selectVariantWithColor(selected_color_name);

    /*
    selected_color_variants = getVariantsByColor(selected_color_name);
    selected_variant = getSelectedVariant(false);
    console.log('selected_variant', selected_variant);
    $('[data-product-select]').val(selected_variant.id).trigger('change');
    selected_color_name = '';
    updateOptionLabels();
    variantImages();
  
    $('[data-product-option-color]').removeClass('active');
    $('[data-product-option-size]').removeClass('active');
    */
  } catch (error) {
    console.log(error);
  }
};

// On first load - Init the correct variant if variant id provided in url
const selectVariantWithId = (variant_id) => {
  try {
    console.log('[ASTR] selectVariantWithId - On first load - Init the correct variant if variant id provided in url');

    selected_color_name = document.querySelector('[data-product-details] [data-product-option-color].active')?.dataset.colorValue;
    selected_size_name = document.querySelector('[data-product-details] [data-product-option-sizes] li.active')?.dataset.sizeValue;

    // If the color is not available, we need to select the 1st available color
    if (typeof selected_color_name === 'undefined') {
      clickColorSwatch(document.querySelector('[data-product-details] [data-product-option-color]:not(.inactive)'));
      return;
    }

    const size_options = document.querySelector('[data-product-details] [data-product-option-sizes]');
    const size_list = size_options.querySelector('ul');

    if (!size_options || !size_list.querySelector('li.active')) {
      // const first_size_option = document.querySelector('[data-product-details] [data-product-option-size]');
      const first_visible_size = Array.from(size_list.children).find(li => !li.classList.contains('hidden'));

      // Note: we don't know at this point if the first size has the class disabled or not. Set in enableAvailableSizes()
      if (first_visible_size) {
        const size_btn = first_visible_size.querySelector('[data-product-option-size]');

        if (size_btn) {
          selected_size_name = size_btn.getAttribute('data-size-value');
        }
      }
    }

    // When color is not automatically pre-selected
    if (!document.querySelector('[data-product-details] [data-product-option-color].active')) {
      const product = getProductJson();
      const variant = product.variants.find(v => v.id === variant_id);

      if (typeof variant !== 'undefined') {
        selected_color_name = variant.option1;
        selected_size_name = variant.option2;

        const color_btn = document.querySelector(`[data-product-details] [data-product-option-color][data-color-value="${selected_color_name}"]`);
        const size_btn = document.querySelector(`[data-product-details] [data-product-option-size][data-size-value="${selected_size_name}"]`);
        if (color_btn) clickColorSwatch(color_btn);
        if (size_btn) selectSize(size_btn);
      }
    }

    selected_color_variants = getVariantsByColor(selected_color_name);
    enableAvailableSizes();

    // We now know which sizes are available for the selected color, it's possible the previously selected size is not available anymore, we need to select the next available size
    const selected_size_item = document.querySelector(`[data-product-details] [data-product-option-size][data-size-value="${selected_size_name}"]`);
    if (!selected_size_item || (selected_size_item && selected_size_item.classList.contains('disabled'))) {
      const first_visible_and_available_size = Array.from(size_list.children).find(li => {
        const btn = li.querySelector('button[data-product-option-size]');
        return btn && !btn.classList.contains('disabled') && !li.classList.contains('hidden');
      });

      if (first_visible_and_available_size) {
        const size_btn = first_visible_and_available_size.querySelector('[data-product-option-size]');

        if (size_btn) {
          selected_size_name = size_btn.getAttribute('data-size-value');
          selectSize(size_btn);
        }
      }
    }

    console.log('[ASTR] selected_color_name', selected_color_name);
    console.log('[ASTR] selected_size_name', selected_size_name);

    // console.log('selected_variant 1', selected_variant);
    selected_variant = getSelectedVariant(true);
    console.log('[ASTR] selected_variant 2', selected_variant);

    // Necessary when the selected size is not available but we still want the 1st size available
    if (typeof selected_variant !== 'undefined') {
      $('[data-product-details] [data-product-select]').val(selected_variant.id).trigger('change');
    }

    if (!$('#quicklook-modal').is(':visible')) {
      updateHistory();
    }

    updateAddToCartStatus();
    variantImages();
    updateOptionLabels(); // after updating the image, we need to update the option labels
    updateOG();
    updateModelInfo();
    updateWishlistButton();

    // Dispatch events for new functionalities
    document.dispatchEvent(new Event('astr-pdp-color-selected'));
  } catch (error) {
    console.log(error);
  }
};

// On first load - Init the correct variant if the product has only one type of option (Gift cards for instance)
const selectVariantWithSingleOption = () => {
  try {
    console.log('[ASTR] selectVariantWithSingleOption - On first load - Init the correct variant if the product has only one type of option (Gift cards for instance)');

    $('[data-single-option-selector] option:selected').val();
    selected_single_option = $('[data-single-option-selector] option:selected').val();
    selected_variant = getVariantBySingleOption(selected_single_option);

    if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
      $('[data-product-select]').val(selected_variant.id).trigger('change');
    }

    updateAddToCartStatus();
    updateHistory();
    variantImages();
    updateOptionLabels(); // after updating the image, we need to update the option labels
    updateOG();
    updateModelInfo();
    updateWishlistButton();
  } catch (error) {
    console.log(error);
  }
};

// product_url is only defined when we come from a quickview
const initSelectVariant = (product_url) => {
  if (typeof product_url !== 'undefined') {
    params = new URL(product_url);
  }

  // Needs to be defined here for the quickview
  size_index = document.querySelector('[data-option-size]') ? Number(document.querySelector('[data-option-size]').dataset.optionIndex) : 1;

  ensureVariantAnnouncementTargets();

  // Avoid announcing the entire product details block on every variant update.
  document.querySelectorAll('[data-product-details]').forEach((el) => {
    el.setAttribute('aria-live', 'off');
  });

  // Select a new color
  document.addEventListener('click', function (e) {
    const item = e.target.closest('[data-product-option-color]');
    clickColorSwatch(item);
  });

  // [ADA] Select a new color
  // $(document).on('focus', '[data-product-option-color]', (e) => {
  //   const $item = $(e.currentTarget);
  //   $item.trigger('click');
  // });
  $(document).on('keypress', '[data-product-option-color]', (e) => {
    const key = e.which;
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  // Select a new available size
  $(document).on('click', '[data-product-option-size]', (e) => {
    const $item = $(e.currentTarget);
    selectSize($item);
  });

  // [ADA] Select a new available size
  // $(document).on('focus', '[data-product-option-size]', (e) => {
  //   const $item = $(e.currentTarget);
  //   $item.trigger('click');
  // });
  $(document).on('keypress', '[data-product-option-size]', (e) => {
    const key = e.which;
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  /*
  // Select a size from the mobile view
  $(document).on('change', '[data-product-option-sizes-mobile]', (e) => {
    const $item = $(e.currentTarget);

    if ($item.val() === '' || $item.val() === null) {
      return;
    }

    // selectSize($item);
    $(`[data-product-option-sizes] [data-product-option-size][data-size-value="${$item.val()}"]`).trigger('click');
  });
  */

  // Select a size from the unavailable modal
  $(document).on('click', '[data-size-oos]', (e) => {
    const $item = $(e.currentTarget);

    $('[data-out-of-stock]').removeClass('non-init');

    $('[data-size-oos]').removeClass('active');
    $item.addClass('active');

    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${$item.data('size-variant-id')}`;
    window.history.replaceState({ path: newUrl }, '', newUrl);
    // window.esc_now_back_in_stock.triggerRefresh();
  });

  // Select a new "single option"
  $(document).on('change', '[data-single-option-selector]', (e) => {
    clickSingleOption(e.currentTarget);
  });

  // Single option products (such as gift cards, gifts with purchases...)
  if ($('[data-single-option-selector]').length) {
    selectVariantWithSingleOption();
    return;
  }

  const colorOptions = document.querySelectorAll('[data-product-option-color]');
  const sizeOptions = document.querySelectorAll('[data-product-option-size]');

  // No color or variant ID in URL
  if (!params.searchParams.get('color') && !params.searchParams.get('variant')) {
    // Only on color swatch, select it
    if (colorOptions.length === 1) {
      selectVariantWithColor(colorOptions[0].dataset.colorValue);
      return;
    }

    // Multiple color swatches but only one color available, select it
    const available_product_colors = getAvailableProductColors();
    if (available_product_colors.length === 1) {
      selectVariantWithColor(available_product_colors[0]);
      return;
    }
  }

  if (colorOptions.length && sizeOptions.length) {
    // It's possible that the url contains both color and variant id, we need to prioritize the variant id
    if (params.searchParams.get('variant')) {
      selectVariantWithId(Number(params.searchParams.get('variant')));
      return;
    }

    if (params.searchParams.get('color')) {
      if (document.querySelectorAll(`[data-color-value="${params.searchParams.get('color')}"]`).length) {
        selectVariantWithColor();
        return;
      }
    }

    selectVariantWithNoParams();
    return;
  }

  console.log('[ASTR] Variant initialization case not found');
};

export {
  initSelectVariant,
  // getSelectedVariant,
  // updateWishlistButton,
  clickColorSwatch,
  selectSize,
};
